module.exports = __webpack_public_path__ + "img/zautla.cfd1dd04.jpg";